import styled from 'styled-components';
import { InputField, TextAreaField } from 'lib/iterable-hook-form/FormField';
import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { EditableLabels } from 'modules/campaigns/lib/components/EditableLabels';
import { getIsJourneyLabelsEnabled, getIsJourneyExitEventsEnabled } from 'modules/workflows/ducks';
import { JourneyDetails } from 'modules/workflows/components/modals/WorkflowDetailsModal/JourneyDetails';
import { useSelector } from 'react-redux';
import { FormField } from 'ui/formField';
import { spacing } from 'ui/theme';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import {
  DESCRIPTION_FIELD,
  NAME_FIELD,
  LABELS_FIELD,
  SettingsTab,
} from '../SettingsTakeover.constants';
import { JourneyDetailText } from './JourneyDetailText';
import {
  PublishedJourneyOptions,
  PublishedJourneyOptionsConsumer,
} from '../../PublishedJourneyOptions/PublishedJourneyOptions';
import { VISITOR_TRACKING_FIELD } from '../../PublishedJourneyOptions/publishedJourneyOptions.constants';

const StyledInput = styled(InputField)`
  margin-bottom: ${spacing.half};
`;

const StyledEditableLabels = styled(EditableLabels)`
  margin-bottom: 0;
`;

type AboutJourneyProps = {
  isDisabled?: boolean;
};

export const NAME_INPUT_TEST_ID = 'name-input';
export const DESCRIPTION_TEXTAREA_TEST_ID = 'workflow-description-textarea';

export const AboutJourney = ({ isDisabled = false }: AboutJourneyProps) => {
  const isJourneyLabelsEnabled = useSelector(getIsJourneyLabelsEnabled);
  const isJourneyExitEventsEnabled = useSelector(getIsJourneyExitEventsEnabled);

  const canDraftMessaging = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.DraftMessaging,
  );

  const shouldDisable = !canDraftMessaging || isDisabled;

  return (
    <>
      <FormField inputId="workflow-name-input" labelText="Journey name">
        <StyledInput
          data-test={NAME_INPUT_TEST_ID}
          name={`${SettingsTab.About}.${NAME_FIELD}`}
          isDisabled={shouldDisable}
        />
        <JourneyDetailText />
      </FormField>
      {isJourneyLabelsEnabled && (
        <StyledEditableLabels
          name={`${SettingsTab.About}.${LABELS_FIELD}`}
          isEditable={!shouldDisable}
        />
      )}
      <FormField inputId="workflow-description-input" labelText="Description">
        <TextAreaField
          id="workflow-description-textarea"
          name={`${SettingsTab.About}.${DESCRIPTION_FIELD}`}
          data-test={DESCRIPTION_TEXTAREA_TEST_ID}
          maxLength={140}
          placeholder={'What are your goals?'}
          isDisabled={shouldDisable}
          isCharacterCountShown
        />
      </FormField>
      {isJourneyExitEventsEnabled && (
        <div>
          <FormField inputId="journey-options-field" labelText="Tracking">
            <PublishedJourneyOptions
              name={`${SettingsTab.About}.${VISITOR_TRACKING_FIELD}`}
              publishedJourneyOptionsConsumer={PublishedJourneyOptionsConsumer.JourneySettings}
              isDisabled={shouldDisable}
            />
          </FormField>
        </div>
      )}
      <JourneyDetails />
    </>
  );
};
